import React from 'react';

import {Dialog} from '@pb/kit-component-dialog-v2';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Tooltip} from '@pb/kit-component-popups';
import {useShown} from '@pb/kit-hooks-use-shown';

import {REMOVE_ALERT_MODAL_WIDTH, RemoveAlertModal} from './remove-alert-modal';

type Props = {
    alertId: number,
    onSuccess: () => void,

};

export const RemoveAlert = ({alertId, onSuccess}: Props) => {
    const {shown, onClose, onClick} = useShown();

    return (
        <>
            <Tooltip anchor={({anchorRef, getAnchorProps}) => (
                <BasicIconButton
                    ref={anchorRef}
                    {...getAnchorProps()}
                    onClick={onClick}
                    iconProps={{type: Icons.TRASH_LIGHT}}
                />
            )}>
                Delete
            </Tooltip>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: REMOVE_ALERT_MODAL_WIDTH}}}>
                <RemoveAlertModal alertId={alertId} onClose={onClose} onSuccess={onSuccess}/>
            </Dialog>
        </>
    );
};
